module.exports = __webpack_public_path__ + "static/media/Impreza-GJ-Sedan-WRX.59442c15.webp";